/**
 * Shared inline styles for the company_admin assessment pages. Matches the
 * card/table language used in DataManagment/Quantative (QuantativeList) so
 * the assessment screens visually slot in alongside the rest of the company
 * admin pages.
 */

export const cardSurface = {
  background: "var(--surface)",
  borderRadius: 12,
  border: "1px solid #e2e6ea",
  overflow: "hidden",
  boxShadow: "0 1px 3px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.05)",
};

/**
 * Same card chrome as `cardSurface` but with the corner clipping kept on.
 * Matches the Quantative KPI table — the container's `borderRadius: 12`
 * + `overflow: hidden` round the table's outer corners (including the
 * grey header row's top corners) without any table-level CSS.
 */
export const tableCardSurface = {
  ...cardSurface,
  overflow: "hidden",
};

export const cardBody = {
  padding: "18px 20px",
};

export const cardHeader = {
  padding: "14px 18px",
  borderBottom: "1px solid var(--rule)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background: "var(--surface)",
};

export const cardHeaderTitle = {
  fontSize: 14,
  fontWeight: 700,
  color: "var(--ink-2)",
  fontFamily: "var(--font-sans)",
  margin: 0,
};

export const thStyle = {
  fontSize: 10,
  fontWeight: 700,
  color: "var(--ink-4)",
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  fontFamily: "var(--font-mono)",
  borderColor: "var(--rule)",
  background: "#f4f6f9",
};

export const formLabel = {
  fontSize: 11,
  color: "var(--ink-4)",
  fontFamily: "var(--font-mono)",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  fontWeight: 700,
  marginBottom: 6,
  display: "block",
};

/**
 * Mirrors `.kpi-btn-primary` from kpiStyles.jsx so the inline-style
 * consumers (assessment pages) match the rest of the company-admin
 * surface (Quantative KPI page, supplier management, etc.).
 */
export const primaryBtn = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "9px 22px",
  background: "var(--ink)",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontSize: 13,
  fontWeight: 700,
  fontFamily: "var(--font-sans)",
  cursor: "pointer",
  letterSpacing: "0.02em",
  whiteSpace: "nowrap",
  transition: "all 0.15s",
};

export const dangerBtn = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "9px 16px",
  background: "transparent",
  color: "var(--red)",
  border: "1.5px solid var(--red)",
  borderRadius: 8,
  fontSize: 13,
  fontWeight: 600,
  fontFamily: "var(--font-sans)",
  cursor: "pointer",
  whiteSpace: "nowrap",
  transition: "all 0.15s",
};

/** Mirrors `.kpi-btn-secondary` from kpiStyles.jsx. */
export const secondaryBtn = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "9px 16px",
  background: "transparent",
  color: "var(--ink-3)",
  border: "1.5px solid var(--rule)",
  borderRadius: 8,
  fontSize: 13,
  fontWeight: 600,
  fontFamily: "var(--font-sans)",
  cursor: "pointer",
  whiteSpace: "nowrap",
  transition: "all 0.15s",
};

export const detailLabel = {
  fontSize: 11,
  color: "var(--ink-4)",
  fontFamily: "var(--font-mono)",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: 4,
};

export const detailValue = {
  fontSize: 13,
  color: "var(--ink-2)",
  fontWeight: 600,
  wordBreak: "break-word",
};

export const statusBadge = (variant = "info") => {
  const palettes = {
    success: { bg: "#e7f6ec", color: "#1f7a3a" },
    warning: { bg: "#fff5d6", color: "#8a5a00" },
    info: { bg: "#e6f0fa", color: "#1e4f7a" },
    muted: { bg: "#eef0f3", color: "#475569" },
    danger: { bg: "#fde7ea", color: "#a01a2b" },
  };
  const p = palettes[variant] || palettes.info;
  return {
    background: p.bg,
    color: p.color,
    fontSize: 11,
    fontWeight: 700,
    padding: "3px 10px",
    borderRadius: 999,
    display: "inline-block",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    fontFamily: "var(--font-mono)",
  };
};
